module.exports = __webpack_public_path__ + "Ford-Pricing-logo2x.afe08b687d2165659b95.png";